import React from 'react';
import { Text } from '@uaveiro/ui';

const Timely = () => (
  <>
    <Text 
      as="p" 
      size="mediumSmall" 
      textAlign="center" 
      marginBottom="4em" 
      marginTop="4em"
      fontWeight="700"
    >
      Devido às políticas de utilização da Timely, não é possível mostrar a pré-visualização dos eventos no Editor.
    </Text>
  </>
);
export default Timely;
